import React from 'react';
import Chart from 'react-apexcharts';
import _ from 'lodash';

const HeatMapChart = (props) => {
    const { chartOptions, chartSeries } = props;
    return (
        <Chart
            height="auto"
            options={_.cloneDeep(chartOptions)}
            series={chartSeries.length ? _.cloneDeep(chartSeries) : [{ name: '', data: [] }]}
            type="heatmap"
            width="100%"
        />
    );
};

export default HeatMapChart;
